import * as React from "react";
import { AtBadge } from "@atman/design-system";
import { Colors } from "../../../styles/variables/colors";
import { IReactSelectOptionObject } from "@atman/business";
import { MultiValueProps, components } from "react-select";

export interface IBadgeMultiValueContainerProps<TValue = IReactSelectOptionObject> extends MultiValueProps<TValue> {}

const BadgeMultiValueContainer: React.FC<IBadgeMultiValueContainerProps> = (props) => {
    const { children, ...otherProps } = props;

    // @ts-ignore
    const [_, removeIcon] = React.Children.toArray(children);

    return (
        <components.MultiValueContainer {...otherProps}>
            <AtBadge size={"sm"} style={{ display: "flex", fontWeight: `bold` }}>
                <span
                    style={{
                        marginRight: 8,
                        color: Colors.greyShades.shade2,
                    }}
                >
                    {props.data.label}
                </span>
                {removeIcon}
            </AtBadge>
        </components.MultiValueContainer>
    );
};

export default BadgeMultiValueContainer;
